import FontLoader from '../lib/FontLoader';

new FontLoader({
  fontFace: 'Ne10-simplified',
  fontClass: 'ne10-loaded'
});
